module.exports = __webpack_public_path__ + "fce4e968256834277ad867a598e29b8d.png";